export const RETRIEVE_USER_ASSIGNMENTS = 'RETRIEVE_USER_ASSIGNMENTS';
export const RETRIEVE_ASSIGNMENT_STATS = 'RETRIEVE_ASSIGNMENT_STATS';
export const SELECT_ASSIGNMENT = 'SELECT_ASSIGNMENT';

export const RETRIEVE_USER_MEMBERSHIPS = 'RETRIEVE_USER_MEMBERSHIPS';
export const SET_USER_DATA = 'SET_USER_DATA';
export const SET_INTL_DATA = 'SET_INTL_DATA';

export const SET_LANE_STEP = 'SET_LANE_STEP';
export const SET_LANE_INFO_MODE = 'SET_LANE_INFO_MODE';
export const SWITCH_LANE_TO_CALL = 'SWITCH_LANE_TO_CALL';

export const RETRIEVE_USER_CALLS = 'RETRIEVE_USER_CALLS';
export const RETRIEVE_ALLOCATED_CALLS = 'RETRIEVE_ALLOCATED_CALLS';
export const START_NEW_CALL = 'START_NEW_CALL';
export const START_CALL_WITH_TARGET = 'START_CALL_WITH_TARGET';
export const DEALLOCATE_CALL = 'DEALLOCATE_CALL';
export const SKIP_CALL = 'SKIP_CALL';
export const SET_CALL_REPORT_FIELD = 'SET_CALL_REPORT_FIELD';
export const SET_CALL_REPORT_STEP = 'SET_CALL_REPORT_STEP';
export const SET_CALLER_LOG_MESSAGE = 'SET_CALLER_LOG_MESSAGE';
export const SET_ORGANIZER_LOG_MESSAGE = 'SET_ORGANIZER_LOG_MESSAGE';
export const FINISH_CALL_REPORT = 'FINISH_CALL_REPORT';
export const SUBMIT_CALL_REPORT = 'SUBMIT_CALL_REPORT';
export const END_CALL_SESSION = 'END_CALL_SESSION';

export const RETRIEVE_CAMPAIGN = 'RETRIEVE_CAMPAIGN';
export const RETRIEVE_CAMPAIGNS = 'RETRIEVE_CAMPAIGNS';
export const RETRIEVE_SURVEY = 'RETRIEVE_SURVEY';
export const RETRIEVE_SURVEYS = 'RETRIEVE_SURVEYS';
export const STORE_SURVEY_RESPONSE = 'STORE_SURVEY_RESPONSE';
export const TOGGLE_SURVEY_INCLUDED = 'TOGGLE_SURVEY_INCLUDED';

export const RETRIEVE_ACTIONS = 'RETRIEVE_ACTIONS';
export const UPDATE_ACTION_RESPONSE = 'UPDATE_ACTION_RESPONSE';

export const SHOW_OVERLAY = 'SHOW_OVERLAY';
export const CLOSE_OVERLAY = 'CLOSE_OVERLAY';

export const PUSH_TUTORIAL_NOTE = 'PUSH_TUTORIAL_NOTE';
export const POP_TUTORIAL_NOTE = 'POP_TUTORIAL_NOTE';



// WEBPACK FOOTER //
// ./src/actions/index.js